/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Apps16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M14 11a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2zm-5 0a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h2zm-5 0a1 1 0 011 1v2a1 1 0 01-1 1H2a1 1 0 01-1-1v-2a1 1 0 011-1h2zm10-5a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2zM9 6a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1h2zM4 6a1 1 0 011 1v2a1 1 0 01-1 1H2a1 1 0 01-1-1V7a1 1 0 011-1h2zm10-5a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1V2a1 1 0 011-1h2zM9 1a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V2a1 1 0 011-1h2zM4 1a1 1 0 011 1v2a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h2z"
        />
    </AccessibleSVG>
);

export default Apps16;
